import { bindActionCreators, Dispatch } from "redux";
import { NotificationActions } from "../store/notification/notification-actions";
import * as CryptoJS from "crypto-js";

const f = () => {
  return "";
};

export const mockTheme: any = {
  zIndex: {
    drawer: {},
  },
  transitions: {
    create: f,
    easing: {},
    duration: {},
  },
  spacing: {
    unit: {},
  },
  palette: {
    primary: {},
    secondary: {},
    common: {},
    background: {
      default: {},
    },
    text: {},
  },
  breakpoints: {
    up: f,
  },
  mixins: {
    toolbar: {},
    gutters: f,
  },
  typography: {
    pxToRem: f,
  },
};

/**
 * This type excludes the 'classes' property that is not
 * required in the interface (the withstyles provides the classes)
 */
export type ExcludeClasses<T> = Pick<
  T,
  Exclude<keyof T, "classes" | "actions" | "notification">
>;

/**
 * This method map a class to an map
 *
 * For example, if we has a class:
 * ```
 * class T {
 *  method1(...) {}
 *  method2(...) {}
 * }
 * ```
 *
 * And we call `toMap(T)`, it will return:
 *
 * ```
 * {
 *  method1: {},
 *  method2: {}
 * }
 * ```
 *
 * This is usefull to use in action mappers, for example:
 *
 * ```
 * const mapDispatchToProps = (dispatch: Dispatch) => ({
 *  actions: bindActionCreators(toMap(T), dispatch)
 * });
 * ```
 * @param actionHolderBuilder the class to map
 * @returns an object with keys as the same as the functions of the instance
 */
export function toMap<T>(actionHolderBuilder: { new (): T }) {
  const actionHolder: any = new actionHolderBuilder();

  const t = {};
  Object.keys(actionHolder.__proto__).forEach((p) => {
    t[p] = actionHolder.__proto__[p].bind(actionHolder);
  });
  return t;
}

export interface WithActions<T> {
  actions: T;
  notification: NotificationActions;
}

/**
 * This is a shorthand for:
 *
 * ```
 * (dispatch) => ({
 * actions: bindActionCreators({
 *  action1,
 *  action2
 *  }, dispatch)
 * )}
 * ```
 *
 * The usage is (T is the class with the actions):
 * ```
 *  connect(mapStateToProps, bindActions(T))(Component)
 * ```
 *
 * @param {{new(): T}} actionHolderBuilder the action class
 * @returns {(dispatch: Dispatch) => {actions: {}, notifications: {}}} the binded actions
 */
export function bindActions<T>(actionHolderBuilder: { new (): T }) {
  return (dispatch: Dispatch) => ({
    actions: bindActionCreators(toMap(actionHolderBuilder), dispatch),
    notification: bindActionCreators(toMap(NotificationActions), dispatch),
  });
}

export function createWhattsappLink(message: string) {
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
}

export function deleteUrlParams() {
  window.history.replaceState(null, "", window.location.pathname);
}

const keyBase64 = "QWJjZGVmZ2hpamtsbW5vcA==";

/**
 * Decrypt an encrypted message
 * @param encryptedBase64 encrypted data in base64 format
 * @return The decrypted content
 */
export function decryptAES(word64EncodedUrlParam: string) {
  // AES KEY EN BASE64
  const word = word64EncodedUrlParam.replace(/_/g, "/").replace(/-/g, "+");
  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
}

function encryptAES(word: string) {
  // AES KEY EN BASE64
  const key = CryptoJS.enc.Base64.parse(keyBase64);
  const encrypt = CryptoJS.AES.encrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  return encrypt;
}

export function getPingToken() {
  const user = "user";
  const pass = "pass";
  class Creds {
    user: string;
    pass: string;
    constructor(userP: string, passP: string) {
      this.user = user;
      this.pass = pass;
    }
  }
  return encryptAES(JSON.stringify(new Creds(user, pass)));
}

const PING_REMISION_URL =
  "https://ping.matizsae.com.py/tag/faces/controlStock/StwCONotaEnvio.xhtml";
// const PING_REMISION_URL =
//   "http://localhost:8088/tag/faces/controlStock/StwCONotaEnvio.xhtml";

// https://multienvios.ping.cosmesoft.com.py/tag/faces/encomiendas/EnwHojasDeRuta.xhtml?hojaRutaId=xyz

// https://multienvios.ping.cosmesoft.com.py/tag/faces/controlStock/StwCONotaEnvio.xhtml?tipo=manifiesto&guiaId=xyz

export function getPingRemisionUrl(remisionId: number) {
  console.log(
    "ping token",
    getPingToken(),
    "encoded",
    encodeURIComponent(getPingToken())
  );
  return (
    PING_REMISION_URL +
    "?remisionId=" +
    remisionId +
    "&token=" +
    encodeURIComponent(getPingToken())
  );
}
// ?tipo=manifiesto&guiaId=xyz
export function getPingUrlAcess(remisionId: number,urlBase: string,prefix:string,) {
  console.log(
    "ping token",getPingToken(),
    "encoded",encodeURIComponent(getPingToken()),
    remisionId, urlBase, prefix
  );
  return (
    urlBase + prefix +
    remisionId +
    "&token=" +
    encodeURIComponent(getPingToken())
  );
}



// WEBPACK FOOTER //
// ./src/utils/utils.ts